import React, { useState } from 'react';
import { 
    ModalWrapper, Modal, ModalHeader, ModalContent, 
    ModalActions, ActionButton, Overlay 
} from './info-modal.styles';

const InfoModal = () => {
    const [accepted, setAccepted] = useState(() => localStorage.getItem('conditions_OK') === 'true');

    const handleClick = () => {
        localStorage.setItem('conditions_OK', 'true');
        setAccepted(true);
    };

    if (accepted) return null;

    return (
        <ModalWrapper>
            <Overlay />
            <Modal>
                <ModalHeader>VARNING</ModalHeader>
                <ModalContent>
                    <h1>Viktigt</h1>
                    <p>Spela ABSOLUT inte BingoBil när du kör bil.</p>
                    <p>Genom att klicka på OK godkänner du att denna webbsida använder cookies.</p>
                    <h1>Regler</h1>
                    <p>Det är tillåtet att byta spelplan upp till tre gånger innan man börjar.</p>
                    <p>Kryssa för de saker du ser längs vägen.</p>
                    <p>5 i rad ger Bingo!</p>
                </ModalContent>
                <ModalActions>
                    <ActionButton onClick={handleClick}>OK</ActionButton>
                </ModalActions>
            </Modal>
        </ModalWrapper>
    );
};

export default InfoModal;